import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { asyncScheduler, Observable, observeOn } from 'rxjs';
import { ChickenTestComponent } from './chicken-test.component';

@Injectable()
export class ChickenTestService {
    constructor(private dialog: MatDialog) { }

    /**
   *
   * @param {string} action - Action to be taken (Are you sure you want to {{Action}}?)
   * @param {string} positive - Label for positive button
   * @param {string} positiveColor - Color for the positive button
   * @param {string} negative - Label for negative button
   * @returns {Observable<boolean>}
   */
    public test(action: string, positive: string, positiveColor = 'primary', negative = 'Cancel', removeFromAllStatements?: string, removeFromAllCloseValue?: any): Observable<boolean> {
        let dialogRef: MatDialogRef<ChickenTestComponent>;

        dialogRef = this.dialog.open(ChickenTestComponent, {
            data: {
                action,
                positive,
                positiveColor,
                negative,
                removeFromAllStatements,
                removeFromAllCloseValue
            } 
        });

        return dialogRef.afterClosed().pipe(observeOn(asyncScheduler));
    }

    public testMessage(action: string, message: string, positive: string, positiveColor = 'primary', negative = 'Cancel'): Observable<boolean> {
        let dialogRef: MatDialogRef<ChickenTestComponent>;

        dialogRef = this.dialog.open(ChickenTestComponent, { maxWidth: '50vw' });
        dialogRef.componentInstance.action = action;
        dialogRef.componentInstance.message = message;
        dialogRef.componentInstance.positive = positive;
        dialogRef.componentInstance.positiveColor = positiveColor;
        dialogRef.componentInstance.negative = negative;

        return dialogRef.afterClosed();
    }

    public discardChanges(positive = 'Confirm', negative = 'Cancel'): Observable<boolean> {
        let dialogRef: MatDialogRef<ChickenTestComponent>;
        dialogRef = this.dialog.open(ChickenTestComponent);
        dialogRef.componentInstance.positive = positive;
        dialogRef.componentInstance.negative = negative;
        return dialogRef.afterClosed();
    }
}
